import React, { useState, useEffect, useRef } from "react";
import { useLanguage } from '../../StoreContext/LanguageContext';
import apiService from "../../config";
import { Printer, Pencil, Save, X, Upload } from "lucide-react";
import { useSignature } from '../../DigitalSignature/UseSignatue';
import SignaturePad from '../../DigitalSignature/SignaturePad';

const TabaPautiTippaniLetters = ({ fetchButtonStatus }) => {
  const letterRef = useRef([]);
  //Send to Project Incharge
  const [showSendToProjectInchargeModal, setShowSendToProjectInchargeModal] = useState(false);
  const [usersProjectIncharge, setUsersProjectIncharge] = useState([]);
  const [loadingUsersProjectIncharge, setLoadingUsersProjectIncharge] = useState(false);
  const [selectedUserProjectIncharge, setSelectedUserProjectIncharge] = useState('');
  const [remarksProjectIncharge, setRemarksProjectIncharge] = useState('');
  const [selectedDocumentProjectIncharge, setSelectedDocumentProjectIncharge] = useState(null);
  const [sendingToProjectIncharge, setSendingToProjectIncharge] = useState(false);
  //Send to Tehsildar
  const [showSendToTehsildarModal, setShowSendToTehsildarModal] = useState(false);
  const [usersTehsildar, setUsersTehsildar] = useState([]);
  const [loadingUsersTehsildar, setLoadingUsersTehsildar] = useState(false);
  const [selectedUserTehsildar, setSelectedUserTehsildar] = useState('');
  const [remarksTehsildar, setRemarksTehsildar] = useState('');
  const [selectedDocumentTehsildar, setSelectedDocumentTehsildar] = useState(null);
  const [sendingToTehsildar, setSendingToTehsildar] = useState(false);
  const [projectId, setProjectId] = useState(null);
  const [proposalId, setProposalId] = useState(null);
  const { language, translations } = useLanguage();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedOwnerIndex, setSelectedOwnerIndex] = useState(null); // null = global edit

  const [fullName, setFullName] = useState('');
  const [designation, setDesignation] = useState('');
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [viewerFile, setViewerFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const {
    uploadStatus,
    uploadError,
    selectedSignDocument,
    resetSignatureState,
    setUploadStatus,
    setUploadError,
    signDocument
  } = useSignature();

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    setFullName(userData.full_name || '');
    setDesignation(userData.designation || '');
  }, []);


  const defaultLetterData = {
    email: "drobuldana@rediffmail.com",
    mobile_no: "07262 - ",
    fax_no: "07262 - 242289",
    notification_no: "कावी/पुनर्वसन-21/मं.आ./166/2025",
    date: new Date().toISOString().split("T")[0],
    subject:
      "जिगांव प्रकल्पामुळे पुनर्वसित गावांणं मोड्या जिगांव तालुका नांदुरा येथील प्रकल्पग्रस्तांना नवीन गावठाण भूखंडाचे पट्टे देणेबाबत",
    reference: "अर्जदाराकडून प्राप्त अर्ज",
    default_content:
      "उपरोक्त विषयाच्या अनुषंगाने अर्जदाराकडून प्राप्त अर्जाच्या अनुषंगाने जिगांव प्रकल्पामुळे पुनर्वसित गावांणं मोड्या जिगांव तालुका नांदुरा येथील प्रकल्पग्रस्तांना जिगांव येथील नवीन गावठाणात खालील नमूद प्रकल्पग्रस्ताचे भूखंडाचे पट्टे तयार करून या सोबत पाठविण्यात येत आहे.",
  };

  // rehabData holds ALL owner records; each record also stores its own letter fields
  const [rehabData, setRehabData] = useState([]);
  // editData is used ONLY while the modal is open (temporary copy of one owner's data)
  const [editData, setEditData] = useState({});
  const talukaName = rehabData?.[0]?.taluka_name || "";
  const districtName = rehabData?.[0]?.district_name || "";


  // Project Id
  useEffect(() => {
    const getProjectInfo = () => {
      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name
          };
        } catch (e) {
          console.error('Error parsing selected project (selectedProject):', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          const projectId = user.data?.project_id || user.project_id;
          const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
          return {
            id: projectId,
            name: projectName
          };
        } catch (e) {
          console.error('Error parsing user data (userData):', e);
        }
      }
      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setProjectId(projectInfo.id);
    console.log('Current Project Info:', projectInfo);
  }, []);

  // Proposal id
  useEffect(() => {
    const getProposalInfo = () => {
      const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

      if (currentProposal) {
        try {
          return {
            proposalId: currentProposal?.data?.default_proposal ||
              currentProposal?.data?.proposal_id ||
              currentProposal?.default_proposal ||
              currentProposal?.proposal_id ||
              null
          }
        } catch (e) {
          console.error('Error parsing current project data (getProposalInfo):', e);
        }
      }
      return { proposalId: null };
    };

    const proposalInfo = getProposalInfo();
    setProposalId(proposalInfo.proposalId);
    console.log('Current Project-Proposal Info:', proposalInfo);
  }, []);

  // Load saved letter data
  useEffect(() => {
    const loadLetter = async () => {
      if (!projectId || !proposalId) return;

      try {
        setLoading(true);
        const response = await apiService.getTabapavtiTippani(projectId, proposalId);

        // API returns { status: 200, data: [...array of owner records] }
        const rawData = response?.data || response || [];
        const dataArray = Array.isArray(rawData) ? rawData : [];

        if (dataArray.length > 0) {
          // Embed letter fields into each owner record.
          // If a record has no letter fields saved yet, fall back to defaults.
          const enriched = dataArray.map((item) => ({
            ...item,
            email: item.email || defaultLetterData.email,
            mobile_no: item.mobile_no || defaultLetterData.mobile_no,
            fax_no: item.fax_no || defaultLetterData.fax_no,
            notification_no: item.notification_no || defaultLetterData.notification_no,
            date: item.date || defaultLetterData.date,
            subject: item.subject || defaultLetterData.subject,
            reference: item.reference || defaultLetterData.reference,
            default_content: item.default_content || defaultLetterData.default_content,
            default_content2: item.default_content2 || "",
            send_to: item.send_to || "",
          }));
          setRehabData(enriched);
        } else {
          setRehabData([]);
        }
      } catch (err) {
        console.warn("No saved tippani letter found → using defaults");
      } finally {
        setLoading(false);
      }
    };

    if (projectId && proposalId) {
      loadLetter();
    }
  }, [projectId, proposalId]);

  const handleSave = async () => {
    if (!projectId || !proposalId) {
      alert("Project / Proposal ID आवश्यक आहे");
      return;
    }
    if (selectedOwnerIndex === null) {
      alert("कोणताही मालक निवडला नाही");
      return;
    }

    setSaving(true);

    try {
      const ownerRecord = rehabData[selectedOwnerIndex];

      const payload = {
        project_id: projectId,
        proposal_id: proposalId,
        rehab_id: ownerRecord?.owner_id ?? null,
        email: editData.email,
        mobile_no: editData.mobile_no,
        fax_no: editData.fax_no,
        notification_no: editData.notification_no,
        date: editData.date,
        subject: editData.subject,
        reference: editData.reference,
        default_content: editData.default_content,
        default_content2: editData.default_content2 || "",
      };

      await apiService.postAddUpdateTabapavtiTippani(payload);

      // Update ONLY this owner's record in rehabData — other owners are untouched
      setRehabData((prev) =>
        prev.map((item, idx) =>
          idx === selectedOwnerIndex
            ? { ...item, ...editData }
            : item
        )
      );

      setIsEditing(false);
      setSelectedOwnerIndex(null);
      setEditData({});
      alert("✓ टिप्पणी पत्र यशस्वीपणे जतन झाले");
    } catch (err) {
      console.error("Save failed:", err);
      alert("❌ जतन करताना त्रुटी आली");
    } finally {
      setSaving(false);
    }
  };

  const USER_ROLES = {
    DATA_ENTRY: 14,
    DRO: 22,
    PROJECT_INCHARGE: 18,
    TEHSILDAR: 5
  };

  // Add this state declaration with your other useState calls:
  const [userRole, setUserRole] = useState(() => {
    try {
      const userData = localStorage.getItem("userData");
      if (userData) {
        const user = JSON.parse(userData);
        return user.user_role || null;
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
    }
    return null;
  });


  const fetchUsersProjectIncharge = async () => {
    const role = 18;
    setLoadingUsersProjectIncharge(true);
    try {
      const response = await apiService.getAllUserRoleProjectIncharge(
        role,
        projectId,
        proposalId
      );

      if (response.status === 200 && response.data) {
        setUsersProjectIncharge(Array.isArray(response.data) ? response.data : []);
      } else {
        setUsersProjectIncharge([]);
      }
    } catch (error) {
      console.error('Error fetching Project Incharge users:', error);
      setUsersProjectIncharge([]);
    } finally {
      setLoadingUsersProjectIncharge(false);
    }
  };

  const fetchUsersTehsildar = async () => {
    const role = 5;
    setLoadingUsersTehsildar(true);
    try {
      const response = await apiService.getAllUserTehsildar(
        role,
        projectId,
        proposalId
      );

      if (response.status === 200 && response.data) {
        setUsersTehsildar(Array.isArray(response.data) ? response.data : []);
      } else {
        setUsersTehsildar([]);
      }
    } catch (error) {
      console.error(error);
      setUsersTehsildar([]);
    } finally {
      setLoadingUsersTehsildar(false);
    }
  };

  useEffect(() => {
    if (showSendToProjectInchargeModal) {
      fetchUsersProjectIncharge();
    }
  }, [showSendToProjectInchargeModal]);

  useEffect(() => {
    if (showSendToTehsildarModal) {
      fetchUsersTehsildar();
    }
  }, [showSendToTehsildarModal]);

  const handleSendToProjectIncharge = async () => {
    if (!selectedUserProjectIncharge || !selectedDocumentProjectIncharge) {
      alert('Please select user and upload document');
      return;
    }

    if (!projectId || !proposalId) {
      alert('Project ID and Proposal ID are required');
      return;
    }

    setSendingToProjectIncharge(true);

    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarksProjectIncharge);
      formData.append('usr_id', selectedUserProjectIncharge);
      formData.append('document', selectedDocumentProjectIncharge);

      const response = await apiService.postTrackingSendToProjectIncharge(formData);

      if (response.status === 200) {
        alert('Successfully sent to Project Incharge');
        setShowSendToProjectInchargeModal(false);
        setSelectedUserProjectIncharge('');
        setRemarksProjectIncharge('');
        setSelectedDocumentProjectIncharge(null);
        fetchButtonStatus();
      } else {
        alert('Failed to send to Project Incharge');
      }
    } catch (error) {
      console.error(error);
      alert('Failed to send to Project Incharge');
    } finally {
      setSendingToProjectIncharge(false);
    }
  };

  const handleSendToTehsildar = async () => {
    if (!selectedUserTehsildar || !selectedDocumentTehsildar) {
      alert('Please select user and upload document');
      return;
    }

    if (!projectId || !proposalId) {
      alert('Project ID and Proposal ID are required');
      return;
    }

    setSendingToTehsildar(true);

    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarksTehsildar);
      formData.append('usr_id', selectedUserTehsildar);
      formData.append('document', selectedDocumentTehsildar);

      const response = await apiService.postTrackingSendToTehsildar(formData);

      if (response.status === 200) {
        alert('Successfully sent to Tehsildar');
        setShowSendToTehsildarModal(false);
        setSelectedUserTehsildar('');
        setRemarksTehsildar('');
        setSelectedDocumentTehsildar(null);
        fetchButtonStatus();
      } else {
        alert('Failed to send to Tehsildar');
      }
    } catch (error) {
      console.error(error);
      alert('Failed to send to Tehsildar');
    } finally {
      setSendingToTehsildar(false);
    }
  };

  const handleUploadedFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    resetSignatureState();     // 🔥 important
    setPdfForSigning(file);
    setShowSignaturePad(true);
  };

  useEffect(() => {
    if (!selectedSignDocument) return;

    const postSignedPdf = async () => {
      try {
        const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
        const projectId = selectedProject?.id || selectedProject?.project_id;
        const proposalId = localStorage.getItem("currentProposalId");

        if (!projectId || !proposalId) {
          console.error("Missing projectId or proposalId");
          return;
        }

        await apiService.postAddSignaturePDF(
          projectId,
          proposalId,
          "TabaPautiTippani",      // 🔁 change per section
          selectedSignDocument   // ✅ signed PDF only
        );

        const sectionRes = await apiService.getSectionFile(
          projectId,
          proposalId,
          "TabaPautiTippani"
        );

        if (sectionRes?.isSignAvailable && sectionRes.data?.[0]?.file_path) {
          setPreviewUrl(sectionRes.data[0].file_path);
        }

      } catch (error) {
        console.error("Error posting signed PDF:", error);
      }
    };

    postSignedPdf();
  }, [selectedSignDocument]);

  const handleViewSignedPdf = async () => {
    try {
      const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
      const projectId = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem("currentProposalId");

      if (!projectId || !proposalId) {
        alert("Project or Proposal not found");
        return;
      }

      const res = await apiService.getSectionFile(
        projectId,
        proposalId,
        "TabaPautiTippani" // 🔁 change per section
      );

      if (res?.isSignAvailable && res?.data?.[0]?.file_path) {
        setViewerFile(res.data[0].file_path);
        setIsViewerOpen(true);     // modal
        // OR 👉 window.open(res.data[0].file_path, "_blank");
      } else {
        alert("Signed document not available");
      }
    } catch (error) {
      console.error("Error viewing signed PDF:", error);
      alert("Unable to open signed document");
    }
  };

  const SignatureLoader = ({ text }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
        <p className="text-sm font-medium text-gray-700">{text}</p>
      </div>
    </div>
  );

  const handlePrint = () => {
    const printContent = letterRef.current?.innerHTML;

    if (!printContent) {
      alert("प्रिंट करण्यासाठी मजकूर उपलब्ध नाही");
      return;
    }

    const printWindow = window.open("", "", "height=950,width=1050");

    printWindow.document.write(`
    <html>
      <head>
        <title>ताबा पावती टिप्पणी पत्र - ${new Date().toLocaleDateString('en-GB')}</title>
        <meta charset="UTF-8">
        <link href="https://fonts.googleapis.com/css2?family=Noto+Serif+Devanagari:wght@400;500;700&display=swap" rel="stylesheet">
        <style>
          @page {
            size: A4 portrait;
            margin: 1.8cm 1.6cm 1.6cm 1.8cm;
          }

          body {
            font-family: "Noto Serif Devanagari", serif;
            font-size: 15px;
            line-height: 1.48;
            color: #000;
            margin: 0;
            padding: 0;
          }

          .letter-container {
            width: 100%;
            max-width: 820px;
            margin: 0 auto;
          }

          .header { text-align: center; margin-bottom: 12px; line-height: 1.4; }
          .info-table, .data-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 18px;
          }

          .info-table td, .data-table th, .data-table td {
            border: 1px solid #000;
            padding: 7px 9px;
          }

          .data-table th {
            background-color: #f5f5f5;
            font-weight: bold;
          }

          .to-section, .subject, .body, .note, .signature, .copies {
            margin-bottom: 16px;
          }

          .signature { text-align: right; margin-top: 40px; }
          .copies ol { padding-left: 24px; margin-top: 8px; }

          /* Hide everything that shouldn't print */
          .no-print, button, .modal, input, select, textarea {
            display: none !important;
          }
        </style>
      </head>
      <body>
        <div class="letter-container">
          ${printContent}
        </div>
      </body>
    </html>
  `);

    printWindow.document.close();

    // Give time for font to load
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
    }, 1000);
  };

  const groupedByOwner = React.useMemo(() => {
    if (!Array.isArray(rehabData)) return {};

    const grouped = {};

    rehabData
      .filter(
        (item) =>
          item.owner_name &&
          typeof item.owner_name === "string" &&
          item.owner_name.trim() !== ""
      )
      .forEach((item) => {
        const key = item.owner_name.trim();

        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(item);
      });

    return grouped;
  }, [rehabData]);


  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-xl">
        लोड होत आहे...
      </div>
    );
  }

  return (
    <>
      {/* Inline CSS */}
      <style>{`
        .letter-container {
          width: 820px;
          margin: 20px auto;
          padding: 30px;
          font-family: "Noto Serif Devanagari", serif;
          font-size: 15px;
          color: #000;
          background: #fff;
        }

        .header {
          text-align: center;
          margin-bottom: 10px;
          line-height: 1.4;
        }

        .info-table,
        .data-table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 15px;
        }

        .info-table td {
          border: 1px solid #000;
          padding: 6px;
          font-size: 14px;
        }

        .to-section {
          margin-bottom: 15px;
        }

        .subject {
          margin-bottom: 10px;
        }

        .body {
          text-align: justify;
          margin-bottom: 15px;
        }

        .data-table th,
        .data-table td {
          border: 1px solid #000;
          padding: 6px;
          text-align: center;
        }

        .note {
          margin-top: 10px;
        }

        .signature {
          margin-top: 30px;
          text-align: right;
        }

        .copies {
          margin-top: 25px;
        }

        .copies ol {
          padding-left: 20px;
        }
      `}</style>

      {/* Action Buttons */}
      <div className="flex justify-between items-center mb-4">
        <div className="flex gap-2">
          {/* <button className="relative">
            <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
              <Upload size={18} />
              <span>Upload Signature</span>
              <input
                type="file"
                accept="application/pdf,image/*"
                className="hidden"
                onChange={handleUploadedFile}
              />
            </label>
          </button>

          <button
            onClick={handleViewSignedPdf}
            className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
          >
            <Printer size={18} />
            <span>View Signed PDF</span>
          </button> */}

          <button
            onClick={handlePrint}
            className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors shadow-sm"
          >
            <Printer size={18} />
            Print
          </button>
        </div>

        <div className="flex flex-wrap items-center gap-3 p-3 lg:ml-auto border border-purple-200 bg-purple-50 rounded-2xl shadow-sm min-w-max">
          <button
            onClick={() => setShowSendToTehsildarModal(true)}
            className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded"
          >
            {translations[language].SendToTehsilar}
          </button>
          <button
            onClick={() => setShowSendToProjectInchargeModal(true)}
            className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded"
          >
            {translations[language].SendToProjectIncharge}
          </button>
        </div>

      </div>

      <div ref={(el) => (letterRef.current = el)}>
        {Object.entries(groupedByOwner).map(([ownerName, ownerRecords], ownerIndex) => (
          <div
            key={ownerIndex}
            className="letter-container"
            style={{ pageBreakAfter: "always" }}
          >
            {/* Header */}
            <div className="header">
              <h3>महाराष्ट्र शासन</h3>
              <h4>पुनर्वसन विभाग</h4>
              <h4>जिल्हाधिकारी कार्यालय, बुलढाणा</h4>
            </div>

            {/* Per-owner Edit button */}
            <div className="no-print" style={{ display: "flex", justifyContent: "flex-end", marginBottom: "8px" }}>
              <button
                onClick={() => {
                  const idx = rehabData.findIndex(
                    (r) => r.owner_id === ownerRecords[0].owner_id
                  );
                  if (idx === -1) return;
                  const rec = rehabData[idx];
                  setSelectedOwnerIndex(idx);
                  setEditData({
                    email: rec.email || defaultLetterData.email,
                    mobile_no: rec.mobile_no || defaultLetterData.mobile_no,
                    fax_no: rec.fax_no || defaultLetterData.fax_no,
                    notification_no: rec.notification_no || defaultLetterData.notification_no,
                    date: rec.date || defaultLetterData.date,
                    subject: rec.subject || defaultLetterData.subject,
                    reference: rec.reference || defaultLetterData.reference,
                    default_content: rec.default_content || defaultLetterData.default_content,
                    default_content2: rec.default_content2 || "",
                    send_to: rec.send_to || "",
                  });
                  setIsEditing(true);
                }}
                style={{
                  display: "flex", alignItems: "center", gap: "6px",
                  padding: "4px 12px", background: "#f97316", color: "#fff",
                  border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "13px"
                }}
              >
                संपादित करा
              </button>
            </div>

            {/* Info Table */}
            <table className="info-table">
              <tbody>
                <tr>
                  <td>Website : <b>www.buldhana.nic.in</b></td>
                  <td>E-mail : <b>{ownerRecords[0].email || defaultLetterData.email}</b></td>
                </tr>
                <tr>
                  <td>दूरध्वनी क्रमांक : {ownerRecords[0].mobile_no || defaultLetterData.mobile_no}</td>
                  <td>फॅक्स क्रमांक : {ownerRecords[0].fax_no || defaultLetterData.fax_no}</td>
                </tr>
                <tr>
                  <td>जा.क्र. : {ownerRecords[0].notification_no || defaultLetterData.notification_no}</td>
                  <td>
                    दिनांक :
                    {(ownerRecords[0].date || defaultLetterData.date)
                      ? new Date(ownerRecords[0].date || defaultLetterData.date).toLocaleDateString("en-GB")
                      : "DD/MM/YYYY"}
                  </td>
                </tr>
              </tbody>
            </table>

            {/* To */}
            <div className="to-section">
              <p>प्रति,</p>
              <p><b>तहसिलदार</b></p>
              <p>नांदुरा</p>
            </div>

            {/* Subject */}
            <div className="subject">
              <p><b>विषय :-</b> {ownerRecords[0].subject || defaultLetterData.subject}</p>
              <p><b>संदर्भ :-</b> {ownerRecords[0].reference || defaultLetterData.reference}</p>
            </div>

            {/* Body */}
            <p className="body">{ownerRecords[0].default_content || defaultLetterData.default_content}</p>

            {/* OWNER NAME */}
            <p style={{ fontWeight: "bold", marginBottom: "8px" }}>
              प्रकल्पग्रस्ताचे नाव : {ownerName}
            </p>

            {/* Data Table */}
            <table className="data-table">
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>प्रकल्पग्रस्ताचे नाव</th>
                  <th>भूखंड क्रमांक</th>
                  <th>क्षेत्र (चौ.मी.)</th>
                  <th>रक्कम</th>
                </tr>
              </thead>
              <tbody>
                {ownerRecords.map((item, index) => (
                  <tr key={item.rehab_id || index}>
                    <td>{index + 1}</td>
                    <td>{item.owner_name}</td>
                    <td>{item.plot_no || "-"}</td>
                    <td>{item.area_sq_mtr || "-"}</td>
                    <td>-</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Note */}
            <p className="note">
              संबंधित व्यक्तींना सदर पट्टा देऊन त्यांची पोच घेऊन या कार्यालयास
              अनुपालन अहवाल सादर करावे.
            </p>

            {/* Signature */}
            <div className="signature">
              <p>(सदाशिव शेलार)</p>
              <p><b>जिल्हा पुनर्वसन अधिकारी</b></p>
              <p>बुलढाणा</p>
            </div>

            {/* Copies */}
            <div className="copies">
              <h4>स्थळ - प्रत</h4>
              <ol>
                <li>कार्यकारी अभियंता जिगांव प्रकल्प विभाग शेगांव</li>
                <li>ग्रामसेवक, ग्रामपंचायत कार्यालय, जिगांव तालुका नांदुरा</li>
                <li>{ownerName}</li>
              </ol>
            </div>
          </div>
        ))}

        {/* Send to Project Incharge Modal */}
        {showSendToProjectInchargeModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="space-y-4">
                  {/* User Selection */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {translations[language]?.SelectProjectIncharge || 'Select Project Incharge'} *
                    </label>
                    <select
                      value={selectedUserProjectIncharge}
                      onChange={(e) => setSelectedUserProjectIncharge(e.target.value)}
                      disabled={loadingUsersProjectIncharge}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">
                        {loadingUsersProjectIncharge ? (translations[language]?.LoadingUsers || 'Loading Users...') : (translations[language]?.SelectUser || 'Select User')}
                      </option>
                      {usersProjectIncharge.map((user) => (
                        <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                          {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Remarks */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {translations[language]?.Remarks || 'Remarks'}
                    </label>
                    <textarea
                      value={remarksProjectIncharge}
                      onChange={(e) => setRemarksProjectIncharge(e.target.value)}
                      rows={3}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter remarks..."
                    />
                  </div>

                  {/* Document Upload */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Upload Document *
                    </label>
                    <input
                      type="file"
                      onChange={(e) => setSelectedDocumentProjectIncharge(e.target.files[0])}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    />
                    {selectedDocumentProjectIncharge && (
                      <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                        <div className="flex items-center justify-between mb-2">
                          <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                            Selected: {selectedDocumentProjectIncharge.name}
                          </p>
                          <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                            {(selectedDocumentProjectIncharge.size / 1024 / 1024).toFixed(2)} MB
                          </span>
                        </div>
                        <div className="flex gap-2">
                          {selectedDocumentProjectIncharge.type === 'application/pdf' && (
                            <button
                              type="button"
                              onClick={() => {
                                if (selectedDocumentProjectIncharge?.type === 'application/pdf') {
                                  setPdfForSigning(selectedDocumentProjectIncharge);
                                  setShowSignaturePad(true);
                                }
                              }}
                              disabled={uploadStatus === 'uploading'}
                              className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                            >
                              {uploadStatus === 'uploading' ? (
                                <>
                                  <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                  Signing...
                                </>
                              ) : (
                                <>
                                  <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                  </svg>
                                  Sign Doc
                                </>
                              )}
                            </button>
                          )}
                        </div>
                        {uploadStatus === 'success' && (
                          <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                            ✅ Document signed successfully!
                          </div>
                        )}
                        {uploadStatus === 'error' && uploadError && (
                          <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                            ❌ {uploadError}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Modal Actions */}
                <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                  <button
                    onClick={() => {
                      setShowSendToProjectInchargeModal(false);
                      setSelectedDocumentProjectIncharge(null);
                      resetSignatureState();
                    }}
                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                    disabled={sendingToProjectIncharge}
                  >
                    {translations[language]?.Cancel || 'Cancel'}
                  </button>

                  <button
                    onClick={handleSendToProjectIncharge}
                    disabled={sendingToProjectIncharge || !selectedUserProjectIncharge || !selectedDocumentProjectIncharge}
                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                  >
                    {sendingToProjectIncharge ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                        {translations[language]?.Sending || 'Sending...'}
                      </>
                    ) : (
                      <>
                        <div className="mr-2 h-4 w-4" />
                        {translations[language]?.send || 'Send'}
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Send to Tehsildar Modal */}
        {showSendToTehsildarModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="space-y-4">
                  {/* User Selection */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {translations[language]?.SelectTehsildar || 'Select Tehsildar'} *
                    </label>
                    <select
                      value={selectedUserTehsildar}
                      onChange={(e) => setSelectedUserTehsildar(e.target.value)}
                      disabled={loadingUsersTehsildar}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">
                        {loadingUsersTehsildar ? (translations[language]?.LoadingUsers || 'Loading Users...') : (translations[language]?.SelectUser || 'Select User')}
                      </option>
                      {usersTehsildar.map((user) => (
                        <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                          {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Remarks */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {translations[language]?.Remarks || 'Remarks'}
                    </label>
                    <textarea
                      value={remarksTehsildar}
                      onChange={(e) => setRemarksTehsildar(e.target.value)}
                      rows={3}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter remarks..."
                    />
                  </div>

                  {/* Document Upload */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Upload Document *
                    </label>
                    <input
                      type="file"
                      onChange={(e) => setSelectedDocumentTehsildar(e.target.files[0])}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    />
                    {selectedDocumentTehsildar && (
                      <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                        <div className="flex items-center justify-between mb-2">
                          <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                            Selected: {selectedDocumentTehsildar.name}
                          </p>
                          <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                            {(selectedDocumentTehsildar.size / 1024 / 1024).toFixed(2)} MB
                          </span>
                        </div>
                        <div className="flex gap-2">
                          {selectedDocumentTehsildar.type === 'application/pdf' && (
                            <button
                              type="button"
                              onClick={() => {
                                if (selectedDocumentTehsildar?.type === 'application/pdf') {
                                  setPdfForSigning(selectedDocumentTehsildar);
                                  setShowSignaturePad(true);
                                }
                              }}
                              disabled={uploadStatus === 'uploading'}
                              className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                            >
                              {uploadStatus === 'uploading' ? (
                                <>
                                  <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                  Signing...
                                </>
                              ) : (
                                <>
                                  <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                  </svg>
                                  Sign Doc
                                </>
                              )}
                            </button>
                          )}
                        </div>
                        {uploadStatus === 'success' && (
                          <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                            ✅ Document signed successfully!
                          </div>
                        )}
                        {uploadStatus === 'error' && uploadError && (
                          <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                            ❌ {uploadError}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Modal Actions */}
                <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                  <button
                    onClick={() => {
                      setShowSendToTehsildarModal(false);
                      setSelectedDocumentTehsildar(null);
                      resetSignatureState();
                    }}
                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                    disabled={sendingToTehsildar}
                  >
                    {translations[language]?.Cancel || 'Cancel'}
                  </button>

                  <button
                    onClick={handleSendToTehsildar}
                    disabled={sendingToTehsildar || !selectedUserTehsildar || !selectedDocumentTehsildar}
                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                  >
                    {sendingToTehsildar ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                        {translations[language]?.Sending || 'Sending...'}
                      </>
                    ) : (
                      <>
                        <div className="mr-2 h-4 w-4" />
                        {translations[language]?.send || 'Send'}
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Edit Modal */}
        {isEditing && (
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-2xl font-bold">
                    {selectedOwnerIndex !== null && rehabData[selectedOwnerIndex]
                      ? `${rehabData[selectedOwnerIndex].owner_name || "भूखंड"} — संपादित करा`
                      : "टिप्पणी पत्र संपादित करा"}
                  </h2>
                  <button onClick={() => { setIsEditing(false); setSelectedOwnerIndex(null); }}>
                    <X size={28} />
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div>
                    <label className="block mb-1 font-medium">ई-मेल</label>
                    <input
                      value={editData.email}
                      onChange={(e) => setEditData({ ...editData, email: e.target.value })}
                      className="w-full border rounded px-3 py-2"
                    />
                  </div>

                  <div>
                    <label className="block mb-1 font-medium">मोबाईल क्रमांक</label>
                    <input
                      value={editData.mobile_no}
                      onChange={(e) => setEditData({ ...editData, mobile_no: e.target.value })}
                      className="w-full border rounded px-3 py-2"
                    />
                  </div>

                  <div>
                    <label className="block mb-1 font-medium">फॅक्स क्रमांक</label>
                    <input
                      value={editData.fax_no}
                      onChange={(e) => setEditData({ ...editData, fax_no: e.target.value })}
                      className="w-full border rounded px-3 py-2"
                    />
                  </div>

                  <div>
                    <label className="block mb-1 font-medium">जा.क्र. (Notification No)</label>
                    <input
                      value={editData.notification_no}
                      onChange={(e) => setEditData({ ...editData, notification_no: e.target.value })}
                      className="w-full border rounded px-3 py-2"
                    />
                  </div>

                  <div>
                    <label className="block mb-1 font-medium">दिनांक</label>
                    <input
                      type="date"
                      value={editData.date}
                      onChange={(e) => setEditData({ ...editData, date: e.target.value })}
                      className="w-full border rounded px-3 py-2"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block mb-1 font-medium">विषय</label>
                    <textarea
                      value={editData.subject}
                      onChange={(e) => setEditData({ ...editData, subject: e.target.value })}
                      rows={3}
                      className="w-full border rounded px-3 py-2"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block mb-1 font-medium">संदर्भ</label>
                    <input
                      value={editData.reference}
                      onChange={(e) => setEditData({ ...editData, reference: e.target.value })}
                      className="w-full border rounded px-3 py-2"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block mb-1 font-medium">मुख्य मजकूर</label>
                    <textarea
                      value={editData.default_content}
                      onChange={(e) => setEditData({ ...editData, default_content: e.target.value })}
                      rows={8}
                      className="w-full border rounded px-3 py-2"
                    />
                  </div>
                </div>

                <div className="flex justify-end gap-4 mt-8">
                  <button
                    onClick={() => { setIsEditing(false); setSelectedOwnerIndex(null); }}
                    className="px-6 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
                  >
                    रद्द करा
                  </button>
                  <button
                    onClick={handleSave}
                    disabled={saving}
                    className="flex items-center gap-2 px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-60"
                  >
                    <Save size={18} />
                    {saving ? "जतन होत आहे..." : "जतन करा"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showSignaturePad && pdfForSigning && (
          <SignaturePad
            pdfFile={pdfForSigning}
            onSign={(signaturesArray) => {
              setShowSignaturePad(false);

              // ✅ ONLY sign here
              signDocument(pdfForSigning, signaturesArray);

              setPdfForSigning(null);
            }}
            onCancel={() => {
              setShowSignaturePad(false);
              setPdfForSigning(null);
            }}
          />
        )}

        {isViewerOpen && viewerFile && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
            <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">

              <div className="flex justify-between items-center px-4 py-2 border-b">
                <h3 className="text-lg font-semibold">Signed Document</h3>
                <button
                  onClick={() => setIsViewerOpen(false)}
                  className="text-xl font-bold"
                >
                  ✕
                </button>
              </div>

              <iframe
                src={viewerFile}
                title="Signed PDF Viewer"
                className="w-full h-full"
              />
            </div>
          </div>
        )}

        {(uploadStatus === "signing" || uploadStatus === "uploading") && (
          <SignatureLoader
            text={
              uploadStatus === "signing"
                ? "Applying digital signature…"
                : "Uploading signed document…"
            }
          />
        )}
      </div>
    </>
  );
};

export default TabaPautiTippaniLetters;